<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import Navbar from '@/nav/GbNavbarReka.vue'
import LicenseBanner from '@/nav/LicenseBanner.vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import { useContentProfileStore } from '@/contentprofile/contentprofile.store'
import { storeToRefs } from 'pinia'
import LoginModal from '@/authentication/LoginModal.vue'
import PremiumActionModal from '@/components/PremiumActionModal.vue'
import Appcues from '@/components/Appcues.vue'
import { showPremiumActionModal } from '@/router/auth_guards'
import SubmitFeedback from '@/components/SubmitFeedback.vue'
import { provideFeedbackContext } from '@/components/useUserFeedbackContext'

const contentProfileStore = useContentProfileStore()
const { profileId } = storeToRefs(contentProfileStore)
const route = useRoute()
const routeName = computed(() => route.name)
const pageTitle = computed(() => route.meta.title as string || 'Toolkit')

getAnalyticsTracker().getChildContext({
  content_profile_id: profileId,
  page_name: routeName
})

provideFeedbackContext()
</script>

<template>
  <header class="relative flex bg-primary-400 md:justify-center">
    <div class="container">
      <Navbar />
    </div>
  </header>
  <LicenseBanner />
  <main>
    <RouterView />
    <LoginModal />
    <PremiumActionModal v-model:external-open="showPremiumActionModal" />
    <Appcues />
    <SubmitFeedback :type="pageTitle" />
  </main>
</template>
